/** �?eweadn 键码转为 ai-hub 爱心蒙版等逻辑使用的标�?*/
export function keyCodeToRhythmLabel(code: string): string {
  if (code.startsWith("Digit")) return code.slice(5);
  if (code.startsWith("Key")) return code.slice(3).toLowerCase();
  if (code.startsWith("Numpad")) {
    const tail = code.slice(6);
    if (tail === "Decimal") return ".";
    if (tail === "Divide") return "/";
    if (tail === "Multiply") return "*";
    if (tail === "Subtract") return "-";
    if (tail === "Add") return "+";
    if (tail === "Enter") return "enter";
    if (tail === "Lock") return "numlock";
    return tail.toLowerCase();
  }
  const map: Record<string, string> = {
    Minus: "-",
    Equal: "=",
    BracketLeft: "[",
    BracketRight: "]",
    Backslash: "\\",
    Semicolon: ";",
    Quote: "'",
    Comma: ",",
    Period: ".",
    Slash: "/",
    Backquote: "`",
    Space: "space",
    Enter: "enter",
    Tab: "tab",
    Backspace: "backspace",
    CapsLock: "caps",
    ShiftLeft: "l-shift",
    ShiftRight: "r-shift",
    ControlLeft: "lctrl",
    ControlRight: "rctrl",
    AltLeft: "lalt",
    AltRight: "r-alt",
    MetaLeft: "lwin",
    ContextMenu: "menu",
    Fn1: "fn1",
    Escape: "esc",
  };
  return map[code] ?? code.toLowerCase();
}
